import React from "react";
import { Description, SubTitle } from "../../Components/CustomComponents";
import ProgressBar from "./ProgressBar";
import _ from "lodash";

const BatchesWithProgress = ({  data }) => {
  // console.log(data);
  return (
    <div className={"ProgressBatches"}>
      <div className={"ProgressBatchCard"}>
        <div className="d-flex ">
          <div className="gradientBg p-2 my-2 rounded-4">
            <img
              alt="batch icon"
              src={data?.image_url}
              width={"60px"}
              className="rounded-3"
            />
          </div>
          <div className="d-flex flex-column align-items-start ms-3 my-auto">
            <SubTitle classes="fs-4 fw-bold" text={data?.name} />
            <Description
              classes="lc-2 text-start"
              text={data?.description
              }
            />
          </div>
        </div>

        <ProgressBar progress={_.round(data?.progress, 2)  } />
      </div>
    </div>
  );
};

export default BatchesWithProgress;
